import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MetaService } from '../../../core/meta.service';
import SwiperCore, { Lazy, Pagination } from 'swiper';

import { IProductGalleryItem } from '../../../models/product-gallery.interface';
import { DialogService } from '../../../utils/dialog/dialog.service';
import { ProductImagePipe } from '../../../utils/product-image.pipe';
import { ProductGalleryCarouselComponent } from './product-gallery-carousel.component';

SwiperCore.use([Pagination, Lazy]);
@Component({
    selector: 'ncg-product-gallery-mobile-carousel',
    template: `
        <div *ngIf="items.length" class="container product-gallery__mobile-carousel">
            <swiper
                [slideClass]="'swiper-slide'"
                [slidesPerView]="'auto'"
                [spaceBetween]="30"
                [pagination]="{ clickable: true, type: 'fraction' }"
                [lazy]="{
                    enabled: true,
                    loadOnTransitionStart: true
                }"
            >
                <ng-template swiperSlide *ngFor="let item of items; let i = index">
                    <div class="is-ratio-product-item">
                        <img
                            (click)="openOverlay(i)"
                            class="swiper-slide__image is-clickable swiper-lazy"
                            [attr.data-src]="item.thumbnail | productImage: 'small'"
                            [attr.data-srcset]="
                                (item.thumbnail | productImage: 'small') +
                                ' 400w,' +
                                (item.thumbnail | productImage: 'medium') +
                                ' 800w,' +
                                (item.thumbnail | productImage: 'large') +
                                ' 1200w'
                            "
                            sizes="100vw"
                            width="400"
                            height="267"
                            [attr.alt]="altText"
                            ncgImageLoad
                        />
                    </div>
                </ng-template>
            </swiper>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductGalleryMobileCarouselComponent implements OnInit {
    @Input()
    public altText: string = '';
    @Input()
    public set media(value: IProductGalleryItem[]) {
        this.items = value
            .filter((x) => x.type === 'image')
            .map((x) => {
                const image: IProductGalleryItem = {
                    src: x.src,
                    thumbnail: x.thumbnail,
                    type: x.type,
                };

                return image;
            });
    }

    public items: IProductGalleryItem[] = [];

    constructor(
        private readonly dialogService: DialogService,
        private readonly metaService: MetaService,
        private readonly productImagePipe: ProductImagePipe
    ) {}

    public ngOnInit(): void {
        const firstImageSrc = this.items[0]?.src;
        if (firstImageSrc) {
            const srcSet =
                this.productImagePipe.transform(firstImageSrc, 'small') +
                ' 400w,' +
                this.productImagePipe.transform(firstImageSrc, 'medium') +
                ' 800w,' +
                this.productImagePipe.transform(firstImageSrc, 'large') +
                ' 1200w';
            this.metaService.setPreloadImage(srcSet, undefined, '100vw', this.productImagePipe.transform(firstImageSrc, 'large'));
        }
    }

    public openOverlay(index = 0) {
        this.dialogService.openDialogWithComponent(ProductGalleryCarouselComponent, {
            fullHeight: true,
            blockScroll: true,
            hasBackdrop: true,
            data: {
                media: this.items,
                mediaIndex: index,
            },
            positionHorizontal: {
                placement: 'center',
            },
        });
    }
}
